import { getMembershipById, getMembershipsAdmin } from "../apis/membershipApi"

const getMemberships = async (id: string) => {
    const response = await getMembershipById(id)
    return response
}

const getMembershipsByAdmin = async () => {
    const response = await getMembershipsAdmin()
    return response
}

export const manageMembershipQueryOptions = (id: string) => {
    return {
        queryKey: ["membership", id],
        queryFn: () => getMemberships(id),
        enabled: !!id, // Only run the query if id is provided
    }
}

export const manageMembershipsByAdmin = () => {
    return {
        queryKey: ["memberships"],
        queryFn: getMembershipsByAdmin
    }
}